import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import Platform from 'src/common/platform'
import { getConfig } from 'src/configs/index.js'
import releaseFromRequire from 'src/release.js'

const config = getConfig()

export const useSystemStore = defineStore('system', () => {
  const prevRoute = ref(null)
  const userDialog = ref({ show: false, type: '', message: '' })
  const release = ref(releaseFromRequire?.version)
  const countOfErrorsChunkLoaded = ref(0)
  const isBot = ref(window.IS_BOT)
  const main = ref(config.code === 'b6e48fe2')
  const alt = ref(config.code === 'r7cb4846')
  const altW = ref(config.code === 'w2f3da42')
  const isWbModalClosed = ref(false)

  const getPlatformName = computed(() => {
    if (alt.value) {
      return 'alt'
    }
    if (altW.value) {
      return 'alt-w'
    }
    if (main.value) {
      return 'main'
    }
    return 'unknown'
  })

  const isMobile = computed(() => {
    if (Platform.is.mobile) {
      return true
    }
    return Platform.is.desktop ? false : Platform.is.ios || Platform.is.android || Platform.is.ipad
  })

  function updateErrorChunks() {
    countOfErrorsChunkLoaded.value++
  }
  function updatePrevRoute(payload) {
    prevRoute.value = payload
  }

  return {
    alt,
    altW,
    countOfErrorsChunkLoaded,
    getPlatformName,
    isBot,
    isMobile,
    isWbModalClosed,
    main,
    prevRoute,
    release,
    updateErrorChunks,
    updatePrevRoute,
    userDialog,
  }
})
